import React, { useState } from 'react';
import './JsonFormatTool.css';

const JsonFormatTool = () => {
  const [jsonInput, setJsonInput] = useState('');
  const [formattedJson, setFormattedJson] = useState('');
  const [error, setError] = useState('');

  const formatJson = () => {
    try {
      const parsedJson = JSON.parse(jsonInput);
      const indentedJson = JSON.stringify(parsedJson, null, 2);
      setFormattedJson(indentedJson);
      setError('');
    } catch (error) {
      setFormattedJson('');
      setError('Invalid JSON format. Please enter valid JSON.');
    }
  };

  return (
    <div className="tool-page-container">
      <div className="tool-page-content">
        <h1>JSON Format Tool</h1>
        <p className="tool-description">
          Format, validate, and beautify JSON data. Paste your JSON below and click format.
        </p>

        <div className="tool-section">
          <label className="tool-label">JSON Input:</label>
          <textarea
            className="json-input"
            value={jsonInput}
            onChange={(e) => setJsonInput(e.target.value)}
            placeholder='Enter JSON data (e.g., {"name": "John", "age": 30})'
          />
        </div>

        <button className="format-button" onClick={formatJson}>
          Format JSON
        </button>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {formattedJson && (
          <div className="result-section">
            <h2>Formatted JSON:</h2>
            <pre className="formatted-output">{formattedJson}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default JsonFormatTool;
